import { connect } from 'react-redux'

import { selectPosition } from '../../../../actions/positionActionCreators'

const mapStateToProps = ({
  selectedPosition,
}, {
  position,
}) => {
  const incumbent = !!position.candidates.find(c => c.incumbent)
  const minCandidates = incumbent ? 1 : 0

  return {
    active: selectedPosition && selectedPosition.position_id === position.position_id,
    filled: position.candidates && position.candidates.length > minCandidates,
    incumbent,
    position,
  }
}

const mapDispatchToProps = (dispatch, { position }) => ({
  onClick: (e) => {
    e.preventDefault()
    dispatch(selectPosition(position))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)



// WEBPACK FOOTER //
// ./src/components/PositionsScene/PositionsList/PositionsListItem/positionsListItemContainer.js